export default "__VITE_ASSET__ba6b17a2__"